export default __webpack_public_path__ + "static/media/Igor-Canova.0acf6d07.png";